import { CATEGORIES, TYPES } from "./types";

interface TemplateBasicInfoFormProps {
  name: string;
  description: string;
  type: "email" | "pdf";
  category: string;
  subject: string;
  subjectSk: string;
  isActive: boolean;
  isNew: boolean;
  language: "cs" | "sk";
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onTypeChange: (value: "email" | "pdf") => void;
  onCategoryChange: (value: string) => void;
  onSubjectChange: (value: string) => void;
  onSubjectSkChange: (value: string) => void;
  onIsActiveChange: (value: boolean) => void;
}

export default function TemplateBasicInfoForm({
  name,
  description,
  type,
  category,
  subject,
  subjectSk,
  isActive,
  isNew,
  language,
  onNameChange,
  onDescriptionChange,
  onTypeChange,
  onCategoryChange,
  onSubjectChange,
  onSubjectSkChange,
  onIsActiveChange,
}: TemplateBasicInfoFormProps) {
  return (
    <div className="card space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="label">Name *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Template name"
            className="input"
            required
          />
        </div>
        <div>
          <label className="label">Description</label>
          <input
            type="text"
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            placeholder="Optional description"
            className="input"
          />
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        <div>
          <label className="label">Type *</label>
          <select
            value={type}
            onChange={(e) => onTypeChange(e.target.value as "email" | "pdf")}
            className="input"
            disabled={!isNew}
          >
            {TYPES.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="label">Category *</label>
          <select
            value={category}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="input"
          >
            {CATEGORIES.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-end">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={isActive}
              onChange={(e) => onIsActiveChange(e.target.checked)}
              className="text-primary-600 h-4 w-4 rounded"
            />
            <span className="text-gray-700 dark:text-gray-300">Active</span>
          </label>
        </div>
      </div>

      {/* Subject for emails */}
      {type === "email" && (
        <div>
          <label className="label">Subject {language === "sk" ? "(SK)" : "(EN)"}</label>
          <input
            type="text"
            value={language === "sk" ? subjectSk : subject}
            onChange={(e) =>
              language === "sk"
                ? onSubjectSkChange(e.target.value)
                : onSubjectChange(e.target.value)
            }
            placeholder="Email subject"
            className="input"
          />
        </div>
      )}
    </div>
  );
}
